import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CoreSidebarService} from '@core/components/core-sidebar/core-sidebar.service';
import {of, Subscription} from 'rxjs';
import {delay, take} from 'rxjs/operators';
import {DashboardService} from './dashboard.service';
import {DashboardFacade} from './store/dashboard.facade';
import { StorageService } from 'app/global/storage.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit, OnDestroy {

  public dashboardSettings = this.dashboardFacade.dashboardSettings$;
  public loginScreenSubscription: Subscription;
  public loading = true;
  constructor(
    private _coreSidebarService: CoreSidebarService,
    public dashboardService: DashboardService,
    private dashboardFacade: DashboardFacade,
    private _storageService: StorageService,
    private _router: Router
  ) {  }
  
  dashboardSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }



  ngOnInit(): void {
    this.dashboardFacade.fetchDashboardSettings();
    this.loading = true;
    this.dashboardSettings.subscribe(() => {
      if (document.readyState === 'complete'){
        if(this.loginScreenSubscription){
          this.loginScreenSubscription.unsubscribe();
        }
        this.stopLoading(300);
      }
      else
      {
        window.addEventListener('load', () => {
          this.stopLoading(300);
        })
      }
    })
  }

  stopLoading(miliseconds)
  {
    if(this.loading){
      this.loginScreenSubscription = of(null)
        .pipe(
              delay(miliseconds),
              take(1)
          ).subscribe(() => {
            this.loading = false;
            const redirectUrl = decodeURIComponent(this._storageService.getItem('redirectAfterLogin') || '');
            if(redirectUrl){
              this._router.navigateByUrl(redirectUrl.replace(/^"|"$/g, ''));
              this._storageService.removeItem('redirectAfterLogin');
            }  
        });
      }
  }

  ngOnDestroy(){
    if(this.loginScreenSubscription){
      this.loginScreenSubscription.unsubscribe();
    }
  }

}
